"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util = __importStar(require("./util.js"));
var const_1 = require("./const");
var BaseCommands = __importStar(require("./commands"));
var BashParser = __importStar(require("./parser"));
var Bash = /** @class */ (function () {
    function Bash(extensions) {
        if (extensions === void 0) { extensions = {}; }
        this.commands = Object.assign(extensions, BaseCommands);
        this.prevCommands = [];
        this.prevCommandsIndex = 0;
    }
    /*
     * This parses and executes the given <input> and returns an updated
     * state object.
     *
     * @param {string} input - the user input
     * @param {Object} state - the current terminal state
     * @returns {Object} the new terminal state
     */
    Bash.prototype.execute = function (input, currentState) {
        this.prevCommands.push(input);
        this.prevCommandsIndex = this.prevCommands.length;
        // Append input to history
        var newState = Object.assign({}, currentState, {
            history: currentState.history.concat({
                cwd: currentState.cwd,
                value: input,
            }),
        });
        var commandList = BashParser.parse(input);
        return this.runCommands(commandList, newState);
    };
    /*
     * This function executes a list of command lists. The outer list
     * is a dependency list parsed from the `&&` operator. The inner lists
     * are groups of commands parsed from the `;` operator. If any given
     * command fails, the outer list will stop executing.
     *
     * @param {Array} commands - the commands to run
     * @param {Object} state - the terminal state
     * @returns {Object} the new terminal state
     */
    Bash.prototype.runCommands = function (commands, state) {
        var _this = this;
        var errorOccurred = false;
        /*
         * This function executes a single command and marks whether an error
         * occurred. If an error occurs, the following dependent commands should
         * not be run.
         */
        var reducer = function (newState, command) {
            if (command.name === '') {
                return newState;
            }
            else if (_this.commands[command.name]) {
                var nextState = _this.commands[command.name].exec(newState, command);
                errorOccurred = errorOccurred || (nextState && nextState.error);
                return nextState;
            }
            else {
                errorOccurred = true;
                return Util.appendError(newState, const_1.Errors.COMMAND_NOT_FOUND, command.name);
            }
        };
        while (!errorOccurred && commands.length) {
            var dependentCommands = commands.shift();
            state = dependentCommands.reduce(reducer, state);
        }
        return state;
    };
    /*
     * This is a very naive autocomplete method that works for both
     * commands and directories. If the input contains only one token it
     * should only suggest commands.
     *
     * @param {string} input - the user input
     * @param {Object} state - the terminal state
     * @param {Object} state.structure - the file structure
     * @param {string} state.cwd - the current working directory
     * @returns {?string} a suggested autocomplete for the <input>
     */
    Bash.prototype.autocomplete = function (input, _a) {
        var structure = _a.structure, cwd = _a.cwd;
        var tokens = input.split(/ +/);
        var token = tokens.pop();
        var filter = function (item) { return item.indexOf(token) === 0; };
        var result = function (str) { return tokens.concat(str).join(' '); };
        if (tokens.length === 0) {
            var suggestions = Object.keys(this.commands).filter(filter);
            return suggestions.length === 1 ? result(suggestions[0]) : null;
        }
        else {
            var pathList = token.split('/');
            token = pathList.pop();
            var partialPath = pathList.join('/');
            var path = Util.extractPath(partialPath, cwd);
            var _b = Util.getDirectoryByPath(structure, path), err = _b.err, dir = _b.dir;
            if (err)
                return null;
            var suggestions = Object.keys(dir).filter(filter);
            var prefix = partialPath ? partialPath + "/" : '';
            return suggestions.length === 1 ? result("" + prefix + suggestions[0]) : null;
        }
    };
    Bash.prototype.getPrevCommand = function () {
        return this.prevCommands[--this.prevCommandsIndex];
    };
    Bash.prototype.getNextCommand = function () {
        return this.prevCommands[++this.prevCommandsIndex];
    };
    Bash.prototype.hasPrevCommand = function () {
        return this.prevCommandsIndex !== 0;
    };
    Bash.prototype.hasNextCommand = function () {
        return this.prevCommandsIndex !== this.prevCommands.length - 1;
    };
    return Bash;
}());
exports.default = Bash;
//# sourceMappingURL=bash.js.map